module.exports = __webpack_public_path__ + "static/media/ban-khar-data.57fa0f2b.svg";